import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Message from './message';
import { MESSAGE_TYPE } from '../../actions';
import { APIMode } from '../../../../../api/types';
import WD from '../../../../../common/icons/wd.svg';
import { CHAT } from '../../types';
import './style.scss';

const Messages = (props) => {
    let prevMessage = null;
    return (
        <>
            {props.agentName === CHAT.WIRTUALNY_KONSULTANT && (
                <div className="opl-widget-chat--messages--header">
                    <WD className="icon-wd" />
                </div>
            )}
            <ul className={`opl-widget-chat--messages ${props.disabled ? 'disabled' : ''}`}>
                {props.messages.map((message, i) => {
                    const m = (
                        <Message
                            key={i}
                            message={message}
                            active={props.messages.length - 1 === i}
                            onSend={props.onSend}
                            API={props.API}
                            disabled={props.disabled}
                            prevMessage={prevMessage}
                        />
                    );
                    prevMessage = message;
                    return m;
                })}
            </ul>
        </>
    );
};

Messages.defaultProps = {
    messages: [],
    disabled: false
};

Messages.propTypes = {
    messages: PropTypes.arrayOf(PropTypes.shape(Message.propTypes).isRequired).isRequired,
    disabled: PropTypes.bool
};

const getVisibleMessages = (
    messages,
    agentjoined,
    sessionActive,
    agentTyping,
    agentName,
    chatMode
) => {
    const excludes = [MESSAGE_TYPE.TRANSFER, MESSAGE_TYPE.CUSTOMMESSAGE];
    let msgs = messages.filter(
        (m) =>
            ((m.type === MESSAGE_TYPE.WELCOME &&
                !agentjoined &&
                sessionActive &&
                chatMode === APIMode.CHAT) ||
                (m.type !== MESSAGE_TYPE.WELCOME && excludes.indexOf(m.type) === -1)) &&
            (m.hidden === undefined || m.hidden === false)
    );
    // filter out some MAX messages
    msgs = msgs.filter(
        (m) =>
            !(
                (m.type === MESSAGE_TYPE.AGENT_JOINED && m.max) ||
                (m.type === MESSAGE_TYPE.AGENT_LEFT && m.max)
            )
    );
    // filter out messages for wirtualny konsultant
    const agentJoins = msgs.filter(
        (m) => m.type === MESSAGE_TYPE.AGENT_JOINED || m.type === MESSAGE_TYPE.TRANSFER
    );
    if (agentJoins.length > 0) {
        const lastJoin = agentJoins[agentJoins.length - 1];
        if (
            agentName === CHAT.WIRTUALNY_KONSULTANT ||
            lastJoin.username === CHAT.WIRTUALNY_KONSULTANT
        ) {
            msgs = msgs.filter(
                (m) =>
                    !(
                        m.type === MESSAGE_TYPE.PROMO ||
                        m.type === MESSAGE_TYPE.AGENT_JOINED ||
                        m.type === MESSAGE_TYPE.AGENT_LEFT
                    )
            );
        }
    }

    if (agentTyping) {
        msgs.push({
            message: `${Message.getFirstName(agentName)} pisze...`,
            username: agentName,
            from: 'agent',
            type: MESSAGE_TYPE.AGENT_TYPING
        });
    }
    return msgs;
};

const mapStateToProps = (state) => {
    return {
        messages: getVisibleMessages(
            state.chat.messages,
            state.chat.agent.joined,
            state.chat.sessionActive,
            state.chat.agentTyping,
            state.chat.agent.name,
            state.chat.mode
        ),
        agentName: state.chat.agent.name
    };
};
export default connect(mapStateToProps)(Messages);
